export default {
  en: {
    your_current_subscription: "Your current subscription",
    next_subscription: "Next subscription",
    beginning: "Beginning",
    amount_of_users: "Amount of users",
    current_user_amount: "Current user amount",
    next_amount_of_users: "Next amount of users",
    your_subscription_has_been_cancelled:
      "Your subscription has been cancelled",
    new_user_amount: "New user amount",
    must_be_greater_than_current_user_amount:
      "Must be greater than current user amount",
    i_know_that_this_change_will_be_effective_retroactively_for_the_current_and_all_next_billing_period_until_it_is_changed_again:
      "I know that this change will be effective retroactively for the current and all next billing period until it is changed again",
    i_know_that_this_change_will_be_effective_beginning_next_billing_period_until_it_is_changed_again:
      "I know that this change will be effective beginning next billing period until it is changed again. Before the next billing period, you can change the user amount again.",
    must_be_checked: "Must be checked",
    increase_current_user_amount: "Increase current user amount",
    change_next_user_amount: "Change next user amount",
    must_be_positive: "Must be positive",
    confirm_chargable_increase: "Confirm chargeable increase",
    confirm_chargable_change: "Confirm chargeable change",
    note: "Note",
    next_subscription_note_text:
      "The next billing period has fewer users than the current billing period. If the number of users in the system is higher than the number set here, the number of users will be automatically increased to the number of users currently in the system when transitioning to the next billing period. Make sure that by the date of the next billing period, the number of users in the system is not higher than the number set here.",
  },
  de: {
    your_current_subscription: "Ihr aktuelles Abonnement",
    next_subscription: "Nächstes Abonnement",
    beginning: "Beginn",
    amount_of_users: "Anzahl der Benutzer",
    current_user_amount: "Aktuelle Anzahl an Benutzern",
    next_amount_of_users: "Nächste Anzahl an Benutzern",
    your_subscription_has_been_cancelled: "Ihr Abonnement wurde gekündigt",
    new_user_amount: "Neue Benutzeranzahl",
    must_be_greater_than_current_user_amount:
      "Muss größer sein als die aktuelle Benutzeranzahl",
    i_know_that_this_change_will_be_effective_retroactively_for_the_current_and_all_next_billing_period_until_it_is_changed_again:
      "Ich weiß, dass diese Änderung rückwirkend für den aktuellen und alle folgenden Abrechnungszeiträume wirksam wird, bis sie erneut geändert wird",
    i_know_that_this_change_will_be_effective_beginning_next_billing_period_until_it_is_changed_again:
      "Ich weiß, dass diese Änderung ab dem nächsten Abrechnungszeitraum wirksam wird, bis sie erneut geändert wird. Vor dem nächsten Abrechnungszeitraum können Sie die Benutzeranzahl erneut ändern.",
    must_be_checked: "Das Kästchen muss aktiviert sein",
    increase_current_user_amount: "Aktuelle Benutzeranzahl erhöhen",
    change_next_user_amount: "Anzahl der nächsten Benutzer ändern",
    must_be_positive: "Muss positiv sein",
    confirm_chargable_increase: "Kostenpflichtige Erhöhung bestätigen",
    confirm_chargable_change: "Kostenpflichtige Änderung bestätigen",
    note: "Hinweis",
    next_subscription_note_text:
      "Die nächste Abrechnungsperiode hat weniger Benutzer als die aktuelle Abrechnungsperiode. Wenn die im System befindliche Benutzeranzahl höher ist als die hier festgelegte Anzahl, wird die Benutzeranzahl bei Übergang in die nächste Abrechnungsperiode automatisch auf die Anzahl der Benutzer erhöht, die sich derzeit im System befinden. Stelle sicher, dass zum Stichtag der nächsten Abrechnungsperiode die Anzahl der Benutzer im System nicht höher ist als die hier festgelegte Anzahl.",
  },
};
